import React, { useState } from 'react'
import InfoRow from './info-row'
import RepresentMoney from '../../utility/represent-money'
import * as API from '../../utility/api'

const TICKETS_URL = 'admin/management/tickets'

const TicketRow = ({ ticket, basket }) => {
  const {
    category_name,
    event_id,
    event_name,
    original_code,
    original_price,
    price_number,
    sale_start_date,
    section_name,
    ticket_row_name,
    ticket_seat_name,
    id,
    ticket_status,
    new_code,
    comments,
    seller_name
  } = ticket
  const [loading, setLoading] = useState('')
  const [commentsText, setCommentsText] = useState(comments)
  const [ticketStatus, setTicketStatus] = useState(ticket_status)
  const [deleted, setDeleted] = useState(false)

  const deleteTicket = () => {
    const confirm = window.confirm('Tahdotko todella poistaa lipun?')

    if (!confirm) return

    setLoading('delete')
    API.DELETE(TICKETS_URL+"/"+id)
      .then(() => {
        setLoading('')
        setDeleted(true)
      })
      .catch(e => {
        console.log({ e })
      })
  }

  const updateTicket = () => {
    setLoading('update')

    API.PUT(TICKETS_URL+"/"+id, {
      ticket: id,
      comments: commentsText,
      status: ticketStatus,
      basket
    })
      .then(() => {
        setLoading('')
      })
      .catch(e => {
        console.log({ e })
      })
  }

  const statusDropdown = (
    <select
      value={ticketStatus}
      onChange={e => setTicketStatus(e.target.value)}
    >
      <option value="REJECTED">Hylätty</option>
      <option value="for_sale">Myynnissä</option>
      <option value="sold">Myyty</option>
      <option value="FROZEN">Jäädytetty</option>
      <option value="expired">Vanhentunut</option>
    </select>
  )

  if (deleted) return <div />

  return (
    <div className="basket-management-ticket-row">
      <InfoRow
        first={['kategoria', category_name]}
        second={['tapahtuma ID', event_id]}
        third={['tapahtuman nimi', event_name]}
      />
      <InfoRow
        first={[
          'alkuperäinen hinta',
          <RepresentMoney sum={original_price} eurSuffix />
        ]}
        second={[
          'Jälleenmyyntihinta',
          <RepresentMoney sum={price_number} eurSuffix />
        ]}
        third={[]}
      />
      <InfoRow
        first={['alkuperäinen koodi', original_code]}
        second={['uusi koodi', new_code]}
        third={['Myyjän nimi', seller_name]}
      />
      <InfoRow
        first={['myyntiinlaittopäivä', sale_start_date]}
        second={['lohko', section_name]}
        third={[
          'istumapaikka',
          ticket_row_name && ticket_seat_name
            ? `rivi: ${ticket_row_name}, paikka: ${ticket_seat_name}`
            : null
        ]}
      />
      <InfoRow
        first={['Lipun status', statusDropdown]}
        second={[]}
        third={[]}
      />

      <div className="break-sm" />

      <div>
        <textarea
          style={{ width: '90%', marginLeft: '15px' }}
          type="text"
          value={commentsText}
          onChange={e => setCommentsText(e.target.value)}
        />
      </div>

      <div style={{ padding: '15px' }}>
        <button
          className="basket-management--ticket-row--button"
          onClick={updateTicket}
        >
          {loading === 'update' ? 'Tallennetaan...' : 'Tallenna muutokset'}
        </button>

        {/* <button className="basket-management--ticket-row--button">
          Tulosta PDF uudestaan
        </button> */}

        <button
          className="basket-management--ticket-row--button"
          onClick={deleteTicket}
        >
          {loading === 'delete' ? 'Poistetaan...' : 'Poista lippu'}
        </button>
      </div>
    </div>
  )
}

export default TicketRow
